import React from 'react';

import { BaseLayout, BaseLayoutProps } from './BaseLayout';

export const AutoDisqualified = (
  props: Omit<BaseLayoutProps, 'headingKey' | 'textKey' | 'showConfetti' | 'actionButton' | 'showIcon'>
) => (
  <BaseLayout
    {...props}
    headingKey='auto_disqualification.heading'
    textKey='auto_disqualification.text'
    showIcon={false}
    showConfetti={false}
    isAutoDisqualification={true}
  />
);

export default AutoDisqualified;
